import { ProposalData } from "../../../../api/gms/proposal/proposal-api-state";
import { SelectedProposal } from "../../../../features/transfer-ownership/transfer-ownership-slice";

interface Props {
    proposals: ProposalData[]
    selectedProposals: SelectedProposal[]
    handleProposalToggle: (value: SelectedProposal) => void;
}

export default function OwnerProposalTbody({
    proposals, 
    selectedProposals,
    handleProposalToggle,
}: Props) {

    return (
        <tbody>
            {proposals.map((proposal) => {
                const status = proposal?.status?.name ?? '-';
                const isSelected = selectedProposals.some( (selected) => selected.id === proposal.application_id );
                const selectedProposal: SelectedProposal = { 
                    id: proposal.application_id, 
                    groupName: proposal.group_name, 
                };
                return (
                    <tr
                        key={proposal.application_id}
                        onClick={() => handleProposalToggle(selectedProposal)}
                        className={`cursor-pointer border-b border-gray-100 transition last:border-b-0 ${isSelected ? 'bg-[#eef6fc]' : 'hover:bg-gray-50'}`}
                    >
                        <td className="px-3 py-3">
                            <button
                                type="button"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleProposalToggle(selectedProposal);
                                }}
                                aria-label={isSelected ? "Deselect proposal" : "Select proposal"}
                                aria-pressed={isSelected}
                                className={`flex h-3.5 w-3.5 items-center justify-center rounded border transition ${
                                    isSelected
                                        ? "border-[#186cb2] bg-[#186cb2] text-white"
                                        : "border-gray-300 bg-white text-transparent hover:border-[#186cb2]"
                                }`}
                            >
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className="h-3.5 w-3.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="m5 12 4 4L19 6" />
                                </svg>
                            </button>
                        </td>
                        <td className="px-3 py-3">
                            <span className="text-[11px] font-semibold text-[#186cb2]">
                                {proposal.RowNum ?? '-'}
                            </span>
                        </td>
                        <td className="px-3 py-3">
                            <span className="text-[11px] font-medium text-gray-700">
                                {proposal.group_name ?? '-'}
                            </span>
                        </td>
                        <td className="px-3 py-3">
                            <span className="text-[11px] text-gray-600">
                                {proposal?.basic_plan?.name ?? '-'}
                            </span>
                        </td>
                        <td className="px-3 py-3">
                            <span className="text-[10px] capitalize text-gray-500">
                                {proposal?.proposal_type?.name ?? '-'}
                            </span>
                        </td>
                        <td className="px-3 py-3">
                            <span className={`inline-flex rounded-full border px-2 py-0.5 text-[9px] font-semibold`}>
                                {status}
                            </span>
                        </td>
                        <td className="px-3 py-3">
                            {/* <span className="text-[10px] text-gray-500"> */}
                            <span className="text-[11px] text-gray-600">
                                {proposal.user_full_name}
                            </span>
                        </td>
                    </tr>
                );
            })}
        </tbody>
    )
}
